"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merchant = require("@/api/merchant");
var _permission = require("@/utils/permission");
var _auth = require("@/utils/auth");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'Information',
  data: function data() {
    var _this = this;
    var validateVal = function validateVal(rule, value, callback) {
      if (_this.labelarr.length === 0) {
        callback(new Error('请输入后回车'));
      } else {
        callback();
      }
    };
    return {
      formConf: {
        fields: []
      },
      isCreate: 0,
      loginType: '0',
      headeNum: [{
        type: '1',
        name: 'API文档'
      }],
      merData: {},
      // 默认数据
      submitLoading: false,
      // 提交loading
      editData: {},
      transferData: {},
      keyNum: 0,
      loading: false,
      merInfoForm: {
        avatar: '',
        backImage: '',
        streetBackImage: '',
        rectangleLogo: '',
        coverImage: '',
        intro: '',
        keywords: '',
        alertStock: 1,
        addressDetail: '',
        serviceType: '',
        serviceLink: null,
        servicePhone: '',
        latitude: '',
        //纬度
        longitude: '',
        //经度
        isTakeTheir: false
      },
      keyUrl: '',
      labelarr: []
    };
  },
  created: function created() {},
  methods: {
    checkPermi: _permission.checkPermi,
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    }
  }
};